import BaseApi from "@api/base.api";
import Http from "@services/http.js";

export default class UnifiedSearchApi extends BaseApi {
    static get entity() {
        return "search/unified";
    }

    static async unifiedSearch(params, config = {}) {
        // Pass the config as the FOURTH parameter (url, data, headers, customConfig)
        return Http.post(this.entity, params, {}, config);
    }

    static async export(params, config = {}) {
        // Use the export endpoint
        return Http.post('search/export', params, {
            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }, config);
    }
}